var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _SignalRClient_connection, _SignalREventsClient_connection, _SignalRSubscription_connection, _SignalRSubscription_method, _SignalRSubscription_callback;
import { HubConnectionBuilder } from '@microsoft/signalr';
import { EventTypes, EventGroups } from '../events';
import { translateEvent } from './signalr-converter';
// generate=ts:SignalRMethods
/** Map of RTCS event name to SignalR method name */
const SIGNALR_METHODS = {
    [EventTypes.agent.away]: 'AgentAway',
    [EventTypes.agent.ready]: 'AgentReady',
    [EventTypes.agent.sessionDelivered]: 'AgentSessionDelivered',
    [EventTypes.agent.sessionOffered]: 'AgentSessionOffered',
    [EventTypes.agent.sessionRejected]: 'AgentSessionRejected',
    [EventTypes.agent.sessionRescinded]: 'AgentSessionRescinded',
    [EventTypes.agent.sessionTerminated]: 'AgentSessionTerminated',
    [EventTypes.agent.status]: 'AgentStatus',
    [EventTypes.agent.wrapupCompleted]: 'AgentWrapupCompleted',
    [EventTypes.agent.wrapupStarted]: 'AgentWrapupStarted',
    [EventTypes.queue.agentAdded]: 'QueueAgentAdded',
    [EventTypes.queue.agentRemoved]: 'QueueAgentRemoved',
    [EventTypes.queue.created]: 'QueueCreated',
    [EventTypes.queue.deleted]: 'QueueDeleted',
    [EventTypes.queue.sessionDelivered]: 'QueueSessionDelivered',
    [EventTypes.queue.sessionJoined]: 'QueueSessionJoined',
    [EventTypes.queue.sessionLeft]: 'QueueSessionLeft',
    [EventTypes.queue.status]: 'QueueStatus',
    [EventTypes.session.created]: 'SessionCreated',
    [EventTypes.session.deleted]: 'SessionDeleted',
};
// end-generate
/** Wrap the provided handler to translate the SignalR event to the RTCS event */
function wrapSignalrHandler(func) {
    return (signalrEvent) => {
        const mappedEvent = translateEvent(signalrEvent);
        return func(mappedEvent);
    };
}
class SignalRClient {
    constructor(connection) {
        _SignalRClient_connection.set(this, void 0);
        Object.defineProperty(this, "events", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        __classPrivateFieldSet(this, _SignalRClient_connection, connection, "f");
        this.events = new SignalREventsClient(connection);
    }
    get state() {
        return __classPrivateFieldGet(this, _SignalRClient_connection, "f").state.toLowerCase();
    }
    close() {
        return __classPrivateFieldGet(this, _SignalRClient_connection, "f").stop();
    }
}
_SignalRClient_connection = new WeakMap();
class SignalREventsClient {
    constructor(connection) {
        _SignalREventsClient_connection.set(this, void 0);
        __classPrivateFieldSet(this, _SignalREventsClient_connection, connection, "f");
    }
    // Implementation of all the `on(...)` overloads
    on(key, func) {
        return __awaiter(this, void 0, void 0, function* () {
            const types = EventGroups[key];
            const wrapped = wrapSignalrHandler(func);
            if (types == null) {
                // Not a group.
                const method = SIGNALR_METHODS[key];
                if (method == null) {
                    throw new Error(`Unknown event type "${key}"`);
                }
                __classPrivateFieldGet(this, _SignalREventsClient_connection, "f").on(method, wrapped);
                return new SignalRSubscription(__classPrivateFieldGet(this, _SignalREventsClient_connection, "f"), key, wrapped, method);
            }
            // Group subscription
            for (const type of types) {
                const method = SIGNALR_METHODS[type];
                __classPrivateFieldGet(this, _SignalREventsClient_connection, "f").on(method, wrapped);
            }
            return new SignalRSubscription(__classPrivateFieldGet(this, _SignalREventsClient_connection, "f"), key, wrapped);
        });
    }
}
_SignalREventsClient_connection = new WeakMap();
class SignalRSubscription {
    constructor(connection, eventKey, callback, signalrMethod) {
        _SignalRSubscription_connection.set(this, void 0);
        _SignalRSubscription_method.set(this, void 0);
        _SignalRSubscription_callback.set(this, void 0);
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.type = eventKey;
        __classPrivateFieldSet(this, _SignalRSubscription_connection, connection, "f");
        __classPrivateFieldSet(this, _SignalRSubscription_callback, callback, "f");
        __classPrivateFieldSet(this, _SignalRSubscription_method, signalrMethod, "f");
    }
    off() {
        if (__classPrivateFieldGet(this, _SignalRSubscription_method, "f") != null) {
            // Just a single specific SignalR method. Use
            // native SignalR .off()
            __classPrivateFieldGet(this, _SignalRSubscription_connection, "f").off(__classPrivateFieldGet(this, _SignalRSubscription_method, "f"), __classPrivateFieldGet(this, _SignalRSubscription_callback, "f"));
            return;
        }
        // A <type>.* group. Iterate the individual
        // event types, fetch their corresponding
        // signalR method names, and .off() each of them
        for (const type of EventGroups[this.type]) {
            const method = SIGNALR_METHODS[type];
            __classPrivateFieldGet(this, _SignalRSubscription_connection, "f").off(method, __classPrivateFieldGet(this, _SignalRSubscription_callback, "f"));
        }
    }
}
_SignalRSubscription_connection = new WeakMap(), _SignalRSubscription_method = new WeakMap(), _SignalRSubscription_callback = new WeakMap();
/** Establishes a connection and returns a new {@link RtcsClient} */
export function connect(options) {
    return __awaiter(this, void 0, void 0, function* () {
        const signalrConnection = new HubConnectionBuilder()
            .withUrl(options.url, {
            withCredentials: false,
        })
            .withAutomaticReconnect()
            .build();
        yield signalrConnection.start();
        signalrConnection.onreconnected((id) => {
            console.log(`Reconnected connection id ${id}`);
            signalrConnection.invoke('Connect', options.accountId);
        });
        yield signalrConnection.invoke('Connect', options.accountId);
        return new SignalRClient(signalrConnection);
    });
}
/** @private Use only in tests */
export const testExports = {
    SignalRClient,
};
//# sourceMappingURL=signalr-client.js.map